import { render, staticRenderFns } from "./FormFinishGrades.vue?vue&type=template&id=e56ac4a2&scoped=true"
var script = {}
import style0 from "./FormFinishGrades.vue?vue&type=style&index=0&id=e56ac4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56ac4a2",
  null
  
)

export default component.exports